var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wrap" } },
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "content_box" }, [
        _c(
          "main",
          { attrs: { id: "wrapMain" } },
          [
            _c("Left", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowLeft,
                  expression: "isShowLeft"
                }
              ]
            }),
            _vm._v(" "),
            _vm.isShowLeft ? _c("Right") : _vm._e(),
            _vm._v(" "),
            !_vm.isShowLeft && _vm.isShow
              ? _c("iframe", { attrs: { src: this.iframe } })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        this.isShowIframe
          ? _c("div", { attrs: { id: "frame" } }, [
              _c("div", { staticClass: "top" }, [
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "span",
                      { staticStyle: { float: "left", "margin-top": "5px" } },
                      [_vm._v("布局：")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: { float: "left" },
                        on: { change: _vm.layout },
                        model: {
                          value: _vm.fontSize,
                          callback: function($$v) {
                            _vm.fontSize = $$v
                          },
                          expression: "fontSize"
                        }
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "上下" } }),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "左右" } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          float: "left",
                          "margin-top": "5px",
                          "margin-left": "10px"
                        }
                      },
                      [_vm._v("分屏：")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: { float: "left" },
                        on: { change: _vm.splited },
                        model: {
                          value: _vm.split,
                          callback: function($$v) {
                            _vm.split = $$v
                          },
                          expression: "split"
                        }
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "3:1" } }),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "2:1" } }),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "1:1" } })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "ql-editor",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.questionData.questionDto.questionContent
                  )
                }
              })
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37982b62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37982b62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testing/testSimulationNew.vue
// module id = null
// module chunks = 